import { Route, Redirect } from "react-router-dom";
import allPaths from "./allPaths";
const PublicRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem("CW_JWT_TOKEN");
  return (
    <Route
      {...rest}
      render={(props) =>
        !token ? (
          <Component {...props} />
        ) : (
          <Redirect to={allPaths.HOME_ROUTE} /> 
        )
      }
    />
  );
};

export default PublicRoute;
